/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  IComandaEtapaReunioes,
  IEtapa,
  StatusReuniaoEnum,
} from '../../../commons/types/crm';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Badge,
  Button,
  Divider,
  Grid,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ProgramaPPC from './ppc';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Aprovar from './Aprovar';
import { useReuniaosActions } from '../../../states/reuniao/reuniao.actions';
import dayjs from 'dayjs';
import DetalhesReuniaoModal from './DetalhesReuniao';
import { useTranslation } from '../../../commons/useTranslasion';
import { esES, ptBR } from '@mui/material/locale';

export interface IEtapaComponent {
  etapa: IEtapa;
  reunioes: IComandaEtapaReunioes[];
  index: number;
  expanded: number;
  handleChange: Function;
  handleChangeReload: Function;
}

const Etapa: React.FC<IEtapaComponent> = ({ etapa, reunioes, index, expanded, handleChange, handleChangeReload }) => {
  const { translate, language } = useTranslation();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }
  
  const [statusList, setStatusList] = useState<{ [key: number]: StatusReuniaoEnum | undefined }>({});
  const [aprovarList, setAprovarList] = useState<{ [key: number]: boolean }>({});
  const [open, setOpen] = useState(false);
  const [detalhesOpen, setDetalhesOpen] = useState(false);
  const [selectedReuniaoId, setSelectedReuniaoId] = useState<number | null>(null);
  const [nota, setNota] = useState(0);
  const [comentario, setComentario] = useState('');
  const [comentarioReprovar, setComentarioReprovar] = useState('');
  const actions = useReuniaosActions();

  useEffect(() => {
    const newStatusList: { [key: number]: StatusReuniaoEnum | undefined } = {};
    const newAprovarList: { [key: number]: boolean } = {};

    reunioes.forEach(reuniao => {
      if (reuniao) {
        newStatusList[reuniao.id] = reuniao.status;
        newAprovarList[reuniao.id] =
          reuniao.status === StatusReuniaoEnum.PENDENTE_APROVACAO &&
          !reuniao.comentarioContato;
      }
    });

    setStatusList(newStatusList);
    setAprovarList(newAprovarList);
  }, [reunioes]);

  const handleApprove = () => {
    if (!selectedReuniaoId) return;

    const reuniao = reunioes.find(r => r.id === selectedReuniaoId);
    if (!reuniao) return;

    actions
      .aprovar(reuniao.tbEtapaId!, reuniao.id!, {
        nota,
        comentario,
      })
      .then(() => {
        handleChangeReload();
        toast.success(translate('aprovado'));
        setStatusList(prev => ({
          ...prev,
          [selectedReuniaoId]: StatusReuniaoEnum.APROVADA
        }));
        setAprovarList(prev => ({
          ...prev,
          [selectedReuniaoId]: false
        }));
        handleClose();
      })
      .catch(() => toast.error(translate('falhaAoAprovar')));
  };

  const handleReject = () => {
    if (!selectedReuniaoId) return;

    const reuniao = reunioes.find(r => r.id === selectedReuniaoId);
    if (!reuniao) return;

    actions
      .reprovar(reuniao.tbEtapaId!, reuniao.id!, {
        comentarioReprovar,
      })
      .then(() => {
        toast.success(translate('reprovado'));
        handleClose();
      })
      .catch(() => toast.error(translate('falhaAoReprovar')));
  };

  const handleClose = () => {
    setNota(0);
    setComentario('');
    setSelectedReuniaoId(null);
    setOpen(false);
  };

  const handleOpenModal = (reuniaoId: number) => {
    setSelectedReuniaoId(reuniaoId);
    setOpen(true);
  };

  const getStatusColor = (status?: StatusReuniaoEnum) => {
    let color = '#b3b3b3';

    if (!status) return color;

    switch (status) {
      case StatusReuniaoEnum.PENDENTE_APROVACAO:
      case StatusReuniaoEnum.APROVADA:
        color = '#ECFDF3';
        break;
      case StatusReuniaoEnum.AGENDADA:
        color = '#33BB49';
        break;
      case StatusReuniaoEnum.CANCELADA:
        color = '#CD0105';
        break;
      case StatusReuniaoEnum.PENDENTE:
      default:
        color = '#FFFAEB';
        break;
    }
    return color;
  };

  const createHTMLFromString = (htmlString: string) => {
    return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
  }

  const getStatusBadges = () => {
    const statusCount: { [key in StatusReuniaoEnum]?: number } = {};

    reunioes.forEach(reuniao => {
      if (reuniao.status) {
        statusCount[reuniao.status] = (statusCount[reuniao.status] || 0) + 1;
      }
    });

    return Object.entries(statusCount).map(([status, count]) => ({
      status: status as StatusReuniaoEnum,
      count,
      color: getStatusColor(status as StatusReuniaoEnum),
    }));
  };

  const handleBadgeClick = (status: StatusReuniaoEnum) => {
    const reuniao = reunioes.find(r => r.status === status);
    if (!reuniao) return;

    setSelectedReuniaoId(reuniao.id);

    if (status !== StatusReuniaoEnum.PENDENTE_APROVACAO) {
      setDetalhesOpen(true);
    } else if (status === StatusReuniaoEnum.PENDENTE_APROVACAO) {
      setOpen(true);
    }
  };

  return (
    <Accordion
      expanded={expanded === index}
      onChange={() => handleChange(index)}
      sx={{
        width: '100%',
        marginBottom: '8px',
        boxShadow: 'none',
        border: '1px solid #E5E5E5',
        borderRadius: '8px !important',
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel${index}-content`}
        id={`panel${index}-header`}
      >
        <Grid container direction="column" spacing={1}>
          <Grid item container alignItems="center" spacing={1}>
            <Grid item>
              <Typography>
                {etapa.nome}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2" color="textSecondary">
                ({reunioes.length} {reunioes.length === 1 ? 'reunião' : 'reuniões'})
              </Typography>
            </Grid>
            {reunioes.some(r => r.status === StatusReuniaoEnum.PENDENTE_APROVACAO) && (
              <Grid item>
                <Tooltip title={translate('existemReunioesAguardandoAprovacao')}>
                  <Badge color="warning">
                    <ErrorOutlineIcon
                      sx={{
                        color: '#FFA726',
                        fontSize: '20px',
                        verticalAlign: 'middle'
                      }}
                    />
                  </Badge>
                </Tooltip>
              </Grid>
            )}
          </Grid>
          <Grid item container spacing={1}>
            {getStatusBadges().map(({ status, count, color }) => (
              <Grid item key={status}>
                <Tooltip title={`${count} ${count === 1 ? 'reunião' : 'reuniões'} - ${status.replace('_', ' ')}`}>
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      handleBadgeClick(status as StatusReuniaoEnum);
                    }}
                    style={{
                      backgroundColor: color,
                      borderRadius: '12px',
                      padding: '4px 8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                      border: '1px solid rgba(0, 0, 0, 0.12)',
                      fontSize: '12px',
                      cursor: [
                        StatusReuniaoEnum.NO_SHOW,
                        StatusReuniaoEnum.PENDENTE_APROVACAO,
                        StatusReuniaoEnum.APROVADA,
                        StatusReuniaoEnum.AGENDADA
                      ].includes(status as StatusReuniaoEnum)
                        ? 'pointer'
                        : 'default',
                    }}
                  >
                    <span style={{ fontWeight: 500 }}>{status.replace('_', ' ')}</span>
                    <span style={{
                      backgroundColor: 'rgba(0, 0, 0, 0.08)',
                      borderRadius: '50%',
                      width: '18px',
                      height: '18px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '11px',
                    }}>
                      {count}
                    </span>
                  </div>
                </Tooltip>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </AccordionSummary>

      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper
              elevation={0}
              sx={{
                padding: '16px',
                borderRadius: '8px',
                marginBottom: '8px',
              }}
            >
              {etapa.nome == translate('analiseDePerfilPlanejamentoCarreira') ? (
                <ProgramaPPC />
              ) : (
                <>
                  {etapa.texto ? (<Typography>{createHTMLFromString(etapa.texto ?? '')}</Typography>) : translate('SemConteudo')}
                </>
              )}
            </Paper>
          </Grid>

          {/*

          {reunioes.map((reuniao, reuniaoIndex) => (
            <>
              {reuniao.status !== StatusReuniaoEnum.NO_SHOW && (
                <Grid item xs={12} key={reuniao.id}>
                  <Paper
                    elevation={0}
                    sx={{
                      padding: '16px',
                      backgroundColor: '#FFFFF',
                      borderRadius: '8px',
                      marginBottom: '8px',
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1">
                          Reunião {reuniaoIndex + 1}
                        </Typography>
                      </Grid>

                      {(reuniao.status !== StatusReuniaoEnum.APROVADA && reuniao.status !== StatusReuniaoEnum.AGENDADA) && (
                        <>
                          <Grid item xs={12} sm={6}>
                            <Typography variant="body2">
                              Status: {statusList[reuniao.id]?.replace('_', ' ')}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Typography variant="body2">
                              Data Prevista: {dayjs(reuniao.dtPrevista).format('DD/MM/YYYY HH:mm')}
                            </Typography>
                          </Grid>
                          {reuniao.dtRealizadaInicio && (
                            <>
                              <Grid item xs={12} sm={6}>
                                <Typography variant="body2">
                                  Início: {dayjs(reuniao.dtRealizadaInicio).format('DD/MM/YYYY HH:mm')}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography variant="body2">
                                  Fim: {dayjs(reuniao.dtRealizadaFim).format('DD/MM/YYYY HH:mm')}
                                </Typography>
                              </Grid>
                            </>
                          )}

                          <Grid item xs={12}>
                            <Typography variant="body2">
                              Consultor: {reuniao.consultorResponsavel?.nome}
                            </Typography>
                          </Grid>
                        </>
                      )}

                      <Divider />

                      {aprovarList[reuniao.id] && (
                        <Grid item xs={12}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleOpenModal(reuniao.id)}
                          >
                            Aprovar/Reprovar
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Paper>
                </Grid>
              )}
            </>
          ))} 

          */}
        </Grid>
      </AccordionDetails>

      <Aprovar
        open={open}
        handleClose={handleClose}
        handleApprove={handleApprove}
        handleReject={handleReject}
        nota={nota}
        setNota={setNota}
        comentario={comentario}
        setComentario={setComentario}
        comentarioReprovar={comentarioReprovar}
        setComentarioReprovar={setComentarioReprovar}
        selectedReuniao={reunioes.find(r => r.id === selectedReuniaoId)}
      />

      <DetalhesReuniaoModal
        open={detalhesOpen}
        handleClose={() => setDetalhesOpen(false)}
        selectedReuniao={reunioes.find(r => r.id === selectedReuniaoId)}
        etapa={etapa}
      />
    </Accordion>
  );
};

export default Etapa;
